import { LitElement, html, css, } from 'lit';
export class AllInDismissable extends LitElement {
    static properties = {
        address: { type: String },
        required: { type: Boolean },
        errorMessage: { type: String },
    };
    constructor() {
        super();
    }
    render() {
        return html `\n        <div class="dismissable_container">\n            <slot></slot>\n            <span class="dismissable">\n                <button @click="${this._dismiss}">Ok</button>\n            </span>\n        </div>\n        `;
    }
    _dismiss() {
        this.remove();
    }
    static styles = [
        css `
        :host {
            font-family:var(--allin-font-family,inherit);
            font-size:var(--allin-font-size,1rem);
            color:var(--allin-text-color,#000);
            background-color:var(--allin-bg-color,transparent);
            padding:var(--allin-padding,0);
            font-weight: var(--allin-font-weight, normal);
        }
        .dismissable_container {
            position: relative;
            padding-right: 2rem;
        }
        .dismissable button {
            position: absolute;
            top: 50%;
            right: 0.5rem;
            padding: 0.5rem;
            border:none;
            background-color: var(--allin-button-bg, #472961);
            color:#fff;
            border-radius: 0.5rem;
            transform: translateY(-50%);
            cursor: pointer;
        }
    `
    ];
}
